<template>
  <div>
    <LoginScreen v-if="!isLoggedIn" @login="handleLogin" :company-name="companyName" />
    <div v-else class="app">
      <!--img v-if="logo" :src="logo" alt="Company logo" />
      <p v-if="loading">Loading...</p>
      <p v-if="error">{{ error }}</p-->
      <!-- <p v-if="conversations">{{ conversations }}</p> -->
      <AppSidebar :conversations="conversations" :conversation-messages-map="conversationMessagesMap" @load-conversation="loadConversation" @new-chat="resetToNewChat"
        @clear-conversation="clearConversation" @refresh-conversations="loadConversations" @logout="handleLogout"
        @collapsed="handleSidebarCollapsed" @update-logo="updateLogo"/>
      <div class="main-content">
        <div :class="['dropdown-container', collapsed ? 'collapsed-dropdown' : ' ']">
          <ChatbotDropdown :chatbots="chatbots" :selectedChatbot="selectedChatbot" @select-chatbot="selectChatbot" />
        </div>
        <div class="header-container">
          <ChatHeader
            v-if="!currentConversation || (currentConversation && currentMessages && currentMessages.length === 0)"
            :logo="logo" :title="selectedChatbot ? selectedChatbot.model_title : ''" />
        </div>
        <ChatMain v-if="!currentConversation || (currentConversation && currentConversation.length === 0)"
          :selectedChatbot="selectedChatbot" @select-prompt="startConversationWithPrompt" />
        <ChatConversation v-else :conversations="currentConversation" :messages="currentMessages" />
        <ChatFooter v-if="selectedChatbot && selectedChatbot.name" @send-message="sendMessage"
          @load-conversation="loadConversation" :isThinking="isThinking" ref="chatFooter" :collapsed="collapsed" />
      </div>
    </div>
  </div>
</template>
 
<script>
import LoginScreen from './components/LoginScreen.vue';
import AppSidebar from './components/AppSidebar.vue';
import ChatHeader from './components/ChatHeader.vue';
import ChatMain from './components/ChatMain.vue';
import ChatConversation from './components/ChatConversation.vue';
import ChatFooter from './components/ChatFooter.vue';
import ChatbotDropdown from './components/ChatbotDropdown.vue';
import axios from '@/axios-config';
import { initTheme, getCurrentTheme } from '@/utils/themeManager';
 
export default {
  components: {
    LoginScreen,
    AppSidebar,
    ChatHeader,
    ChatMain,
    ChatConversation,
    ChatFooter,
    ChatbotDropdown
  },
 
  data() {
    return {
      currentConversation: null,
      currentMessages: [],
      conversations: [],
      chatbots: [],
      selectedChatbot: null,
      isNewConversation: true,
      isLoggedIn: false, // Track the login state
      newMessage: '',
      currentUser: null,
      isThinking: false,
      collapsed: false,
      conversationMessagesMap: {},
      logo: null,      // reference to logo throughout site
      companyName: null,
      companyInfo: {},
      loading: true,
      error: null,
    };
  },
  created() {
    this.fetchCompanySettings();
    this.loadChatbots();
    this.loadConversations();
    this.pickDefaultChatbot();

    axios.get('/api/user/', { withCredentials: true })
      .then(res => {
        this.currentUser = res.data
        console.log('User is logged in:', res.data)
        this.isLoggedIn = true
        this.pickDefaultChatbot();
      })
      .catch(() => {
        console.log('User not logged in')
      })
  },
 
  computed: {
    filteredConversations() {
      return this.conversations.filter(convo => convo.chatbot === this.selectedChatbot);
    }
  },
  methods: {
    async fetchCompanySettings() {
      this.loading = true;
      this.error = null;
      try {
        const companyInfoResponse = await axios.get('/api/company-setting/');
        this.companyInfo = companyInfoResponse.data;
        this.logo = this.companyInfo.logo || this.logo;

        if(getCurrentTheme().includes('dark'))
        {
          this.logo = this.companyInfo.logo_dark_mode; 
        }
        this.companyName = this.companyInfo.company_name;

        // Initialize theme system with theme family from backend
        const themeFamily = this.companyInfo.theme_family;
        initTheme(themeFamily);
      } catch (err) {
        console.error(err);
        this.error = 'Failed to load company settings';
        // Initialize with default theme if fetch fails
        initTheme();
      } finally {
        this.loading = false;
      }
    },
    updateLogo(){
      if(getCurrentTheme().includes('dark'))
      {
        this.logo = this.companyInfo.logo_dark_mode; 
      }
      else
      {
        this.logo = this.companyInfo.logo;
      }
    },
    pickDefaultChatbot() {
      if (!this.chatbots.length || !this.currentUser) return;   // need both

      const wantsFFGA = this.currentUser.email?.toLowerCase().endsWith('@ffga.com');

      // Look for bots by botid instead of hardcoded IDs
      let targetBotId;
      if (wantsFFGA) {
        targetBotId = 'ffga';
      } else {
        targetBotId = 'camgpt';
      }

      const bot = this.chatbots.find(b => b.botid === targetBotId);
      if (bot) {
        this.selectedChatbot = bot;
      } else {
        // Fallback to first available bot
        this.selectedChatbot = this.chatbots[0];
      }
    },
    handleSidebarCollapsed(isCollapsed) {
      this.collapsed = isCollapsed;
    },
 
 
    async loadConversations() {
      try {
        const response = await axios.get('/api/conversation/', { withCredentials: true });
        this.conversations = response.data;
 
        // Fetch messages for each conversation
        const messagesMap = {};
        const messagePromises = this.conversations.map(async (conv) => {
          try {
            const res = await axios.get(`/api/conversation/${conv.resource_id}/messages/`);
            messagesMap[conv.resource_id] = res.data;
          }
          catch (err) {
            console.err(`Failed to load messages for ${conv.resource_id}`, err)
            messagesMap[conv.resource_id] = [];
          }
        });
 
        await Promise.all(messagePromises);
        this.conversationMessagesMap = messagesMap;
 
        this.pickDefaultChatbot();
      } catch (error) {
        console.error("Error loading conversations:", error);
      }
    },
 
    async loadChatbots() {
      try {
        const response = await axios.get('/api/assistant/');
        this.chatbots = response.data;
        this.pickDefaultChatbot();
      } catch (error) {
        console.error("Error loading chatbots:", error);
      }
    },
    resetToNewChat() {
      this.pickDefaultChatbot();
      this.currentConversation = null;
      this.isNewConversation = true;
      // this.clearcurrentMessages = []; <- whatever this is, its wrong.
      this.currentMessages = [];
 
    },
 
    loadConversation(conversation) {
 
 
      this.currentConversation = conversation;
 
      // Find the matching chatbot by ID (conversation.ai_assistant contains the AI assistant ID)
      const chatbot = this.chatbots.find(bot => bot.id === conversation.ai_assistant);
      this.selectedChatbot = chatbot;
 
      if(chatbot) this.selectedChatbot=chatbot;
      this.isNewConversation = false;
      const url = `/api/conversation/${conversation.resource_id}/messages/`;
      axios.get(url)
        .then(response => {
 
 
          if (!Array.isArray(response.data)) {
            this.currentMessages = [];
          } else {
            this.currentMessages = response.data;
          }
 
          console.log("current messages loaded here", response.data)
 
        })
        .catch(error => {
          console.error("Error loading conversation messages:", error);
 
          if (!this.currentMessages) {
            this.currentMessages = [];
          }
        });
    },
 
    async startNewChat(message) {
      console.log('Attempting to send API request...');
      const res = await axios.get('/api/get-csrf-token');
      const token = res.data.csrfToken;
      try {
        const response = await axios.post(
          '/api/newconvo/',
          {
            assistant: this.selectedChatbot,
            user_message: message
          }, {
          headers: {
            'X-CSRFToken': token
          }
        }
        );
        this.currentConversation = response.data;
        this.currentMessages.push({
          role: 'user',
          content: message
        });
        this.isNewConversation = false;
 
        return this.currentConversation
      } catch (error) {
        console.error("Error starting new conversation:", error);
      }
    },
 
 
    async clearConversation(conversationId) {
      const conversation = this.conversations.find(convo => convo.id === conversationId);
      this.conversations = this.conversations.filter(convo => convo.id !== conversationId);
      const url = `/api/clearconvo/${conversation.resource_id}/`;
      console.log('Attempting to send API request...');
      const res = await axios.get('/api/get-csrf-token');
      const token = res.data.csrfToken;
      axios.post(url, null, {
        headers: {
          'X-CSRFToken': token
        },
      });
      if (this.currentConversation && this.currentConversation.id === conversationId) {
        this.currentConversation = null;
        this.isNewConversation = true;
      }
      this.currentMessages = [];
    },
 
    async clearcurrentMessages() {
      this.currentMessages = []
    },
 
    async sendMessage(message) {
      // show the thinking bubble
      this.isThinking = true
      const res = await axios.get('/api/get-csrf-token');
      const token = res.data.csrfToken;
      if (!this.currentConversation || this.isNewConversation) {
 
        const conv = await this.startNewChat(message);
 
        if (!conv) {
          console.error("Failed to create a new conversation.");
          this.isThinking=false;
          return;
        }
        this.currentConversation = conv;
 
        if (!this.conversations.some(
          convo => convo.resource_id === this.currentConversation.resource_id
        )) {
          this.conversations.unshift(this.currentConversation);
 
        }
      } else {
        this.currentMessages.push({
          role: 'user',
          content: message
        });
        if (!this.currentMessages) {
          this.currentMessages = [];
        }
 
 
      }
      // Call the API for the AI response
      const conversationId = this.currentConversation.resource_id;
 
 
      const botId = this.selectedChatbot ? this.selectedChatbot.id : undefined;
      const botType = this.selectedChatbot ? this.selectedChatbot.botid : undefined;
      
      // Debug logging
      console.log('Selected chatbot:', this.selectedChatbot);
      console.log('Bot ID:', botId, 'Bot Type:', botType);
      
      //unified endpoint for all AI assistants
      const apiUrl = '/api/unified-assistant-response/';
      
      console.log('Using unified API URL:', apiUrl);
 
 
 
 
 
      try {
        const response = await axios.post(apiUrl, {
          conversation_id: conversationId,
          botid: botType,
          user_message: message,
        }, {
          headers: {
            'X-CSRFToken': token
          }
        });
        // show the thinking bubble
        this.isThinking = false;
        this.currentMessages.push({
          role: 'assistant',
          html_content: response.data.reply
        });
 
 
        this.$refs.chatFooter.enableInput();
      } catch (error) {
        console.error("Error fetching AI response:", error);
        if (!this.currentMessages) {
          this.currentMessages = [];
        }
        this.currentMessages.push({
          type: 'system',
          text: 'Failed to get a response from the AI.'
        });
      }finally{
        if(this.$refs.chatFooter && this.$refs.chatFooter.enableInput)
      {
        this.$refs.chatFooter.enableInput();
      }
    }
  },
 
    startConversationWithPrompt(prompt) {
      console.log('starting conversation with prompt:', prompt);
      this.sendMessage(prompt);
    },
 
    selectChatbot(bot) {
 
 
      this.selectedChatbot = bot;
 
      this.currentConversation = null;
      this.isNewConversation = true;
      this.currentMessages = [];
    },

    handleLogin() {
      this.isLoggedIn = true; // Set login state to true
      window.location.href = '/accounts/microsoft/login/';
    },
    handleLogout() {
      window.location.href = "/logout/";
      this.isLoggedIn = false; // Set login state to false
    },
  },
 
};
</script>
 
<style scoped>
html,
body{
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
}
 
.app {
  display: flex;
  height: 100vh;
  overflow: hidden;
  /* Prevent horizontal scrolling */
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100% - 20rem);
  /* Subtract the sidebar width */
  min-width: 0;
  /* Ensure the main content can shrink if necessary */
  overflow: hidden;
  /* Hide any overflow */
  flex-grow: 1;
  /* Allow main content to grow and shrink as needed */
}
 
.dropdown-container {
  position: absolute;
  top: 0px;
  left: calc(20rem + 20px);
}
 
.collapsed-dropdown {
  left: calc(60px + 20px);
}
 
.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  font-family: TT Ramillas Trl, Inter, sans-serif;
}
</style>
 